import {initializeApp} from "firebase/app";
import {Auth, getAuth} from "firebase/auth";
import {Firestore, getFirestore} from "firebase/firestore";
import {deleteObject, FirebaseStorage, getDownloadURL, getMetadata, getStorage, list, listAll, ref, uploadBytes,} from "firebase/storage";
import {StorageFile} from "../model/StorageFile";

const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
const AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
const MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
const firebaseConfig = {
  apiKey: API_KEY,
  authDomain: AUTH_DOMAIN,
  projectId: PROJECT_ID,
  storageBucket: STORAGE_BUCKET,
  messagingSenderId: MESSAGING_SENDER_ID,
  appId: APP_ID,
  measurementId: MEASUREMENT_ID,
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Exporter les services Firebase utilisés
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);
export const storageRoot = "";

export async function listFilesInFolder(folder: string): Promise<StorageFile[]> {
  const result = await listAll(ref(storage, folder));
  return Promise.all(
    result.items.map(async (itemRef) => {
      const [url, metadata] = await Promise.all([
        getDownloadURL(itemRef),
        getMetadata(itemRef),
      ]);
      return {
        name: itemRef.name,
        fullPath: itemRef.fullPath,
        url,
        size: metadata.size,
        timeCreated: metadata.timeCreated,
      };
    })
  );
}

export async function deleteFileFromPath(fullPath: string): Promise<void> {
  await deleteObject(ref(storage, fullPath));
}

export async function deleteFileFromUrl(url: string) {
  try {
    const match = url.match(/\/o\/([^?]+)/);
    if (!match) {
      throw new Error(
        "URL invalide : impossible d'extraire le chemin du fichier.",
      );
    }
    const decodedPath = decodeURIComponent(match[1]); // ex: "deals/L5lRMWAgqRZ6nOvf8QCJ.jpg"
    const fileRef = ref(storage, decodedPath);
    await deleteObject(fileRef);
  } catch (error) {
    console.error("❌ Erreur lors de la suppression du fichier :", error);
    throw error;
  }
}

export const uploadFile = async (
  file: File,
  id: string,
  collection: string,
): Promise<string | undefined> => {
  if (file !== undefined) {
    const regex = /(?:\.([^.]+))?$/;
    const newFile = new File([file], id + "." + regex.exec(file.name)![1], {
      type: file.type,
    });
    const fileRef = ref(storage, storageRoot + collection + newFile.name);
    const allImage = await list(ref(storage, storageRoot + collection));
    const imageName = allImage.items
      .map((item) => item.name)
      .find((name) => name.match(id));
    if (imageName) {
      await deleteObject(ref(storage, collection + imageName));
    }
    await uploadBytes(fileRef, newFile);
    return await getDownloadURL(fileRef);
  }
  return;
};
